(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-offer-badge"] && !Shopify.designMode) return;
  try {
    (function () {
  var productId;
  var eligibleIds = [];

  function getBadge() {
    return document.getElementById("buy-offer-badge");
  }

  function init() {
    var badge = getBadge();
    if (!badge) return;
    productId = badge.dataset.productId;
    var dataEl = document.getElementById("buy-offer-variants-" + productId);
    if (dataEl) {
      eligibleIds = JSON.parse(dataEl.textContent);
    }
  }

  function toggleBadge(variantId) {
    var badge = getBadge();
    if (!badge) return;
    var id = parseInt(variantId, 10);
    if (eligibleIds.includes(id)) {
      badge.removeAttribute("hidden");
    } else {
      badge.setAttribute("hidden", "");
    }
  }

  function getVariantFromUrl() {
    var url = new URL(window.location.href);
    return url.searchParams.get("variant");
  }

  function checkUrl() {
    var variantId = getVariantFromUrl();
    if (variantId) {
      toggleBadge(variantId);
    }
  }

  init();
  checkUrl();

  var originalReplaceState = history.replaceState;
  var originalPushState = history.pushState;

  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    checkUrl();
  };

  history.pushState = function () {
    originalPushState.apply(this, arguments);
    checkUrl();
  };

  window.addEventListener("popstate", checkUrl);

  document.addEventListener("change", function (e) {
    var picker = e.target.closest("variant-selects, variant-radios");
    if (picker) {
      setTimeout(checkUrl, 50);
      return;
    }
    var form = e.target.closest("form[action*=\"/cart/add\"]");
    if (form) {
      var input = form.querySelector("input[name=\"id\"], select[name=\"id\"]");
      if (input) {
        toggleBadge(input.value);
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
